/* Hero food videos: lazy-attach and play only the visible slide's clip.
   Loads after window "load" so it never competes with LCP. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  if (reduce || conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;

  var small = window.matchMedia('(max-width: 639px)');
  var heroVisible = true;

  function srcFor(v) { return small.matches ? v.dataset.srcSm : v.dataset.srcLg; }

  function play(v) {
    if (!v) return;
    if (!v.getAttribute('src')) {
      v.setAttribute('src', srcFor(v));
      v.preload = 'auto';
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function activeSlide() {
    return document.querySelector('.hero-story-swiper .swiper-slide-active') ||
           document.querySelector('.hero-story-swiper .swiper-slide');
  }

  function sync() {
    var active = activeSlide();
    document.querySelectorAll('[data-tnm-hero-video]').forEach(function (v) {
      var inActive = active && active.contains(v);
      if (inActive && heroVisible) { play(v); } else if (!v.paused) { v.pause(); }
    });
  }

  function init() {
    var root = document.querySelector('.hero-story-swiper');
    if (!root) return;
    // Swiper toggles swiper-slide-active; watch class changes instead of coupling to its API.
    new MutationObserver(sync).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15, rootMargin: '200px' }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      heroVisible = !document.hidden;
      sync();
    });
    sync();
  }

  if (document.readyState === 'complete') { init(); }
  else { window.addEventListener('load', init, { once: true }); }
})();
